<template>
  <div class="main">
    <div class="main__question">
      <label for="question" class="question__label">Спросить</label>
      <textarea
        id="question"
        v-model="question"
        placeholder="Спроси что-нибудь"
        class="question__input"
      />
    </div>
    <div class="main__answer">
      <p class="answer__text">{{ answer }}</p>
    </div>
    <div class="main__timer">
      <timer />
    </div>
    <sleepwalking class="main__sleepwalking" @click="getAnswer()" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Sleepwalking from "../components/Sleepwalking.vue";
import Timer, { setupTimer } from "../components/Timer.vue";

class Question implements QuestionInterface {
  readonly question: string;
  readonly answer: string;

  constructor(question: string, answer: string) {
    this.answer = answer;
    this.question = question;
  }
}

interface QuestionInterface {
  readonly question: string;
  readonly answer: string;
}

interface WalkInfoInterface {
  readonly dateTime: string;
  readonly questions: Array<QuestionInterface>;
}

function setup() {
  const { canWalk, timeStart } = setupTimer();

  const question = ref("");
  const answer = ref("");

  // Данные о прогулке
  const lsQuestions = localStorage.getItem("questions");
  console.log(lsQuestions);
  let wi: WalkInfoInterface;
  const allQuestions: Array<WalkInfoInterface> = lsQuestions
    ? JSON.parse(lsQuestions)
    : new Array<WalkInfoInterface>();

  if (
    lsQuestions &&
    (new Date(allQuestions[allQuestions.length - 1].dateTime)).getTime() === timeStart.getTime()
  ) {
    wi = allQuestions[allQuestions.length - 1];
  } else {
    wi = {
      dateTime: timeStart.toString(),
      questions: new Array<Question>()
    };
    allQuestions.push(wi);
    localStorage.setItem("questions", JSON.stringify(allQuestions));
  }

  const commitNewQuestion = (que: Question) => {
    wi.questions.push(que);
    allQuestions[allQuestions.length - 1] = wi;
    localStorage.setItem("questions", JSON.stringify(allQuestions));
  };

  // Обработка ответа
  const getAnswer = () => {
    if (canWalk()) {
      if (question.value.length > 3 && question.value.search("[?]") !== -1) {
        answer.value = "Хм...";
        setTimeout(() => {
          answer.value = Math.random() < 0.5 ? "Да." : "Нет.";
          commitNewQuestion(new Question(question.value, answer.value));
        }, 1000);
      } else {
        answer.value = "Не могу разобрать вопрос.";
      }
    } else {
      answer.value = "Встретимся позже.";
    }
  };

  return {
    question,
    answer,
    getAnswer
  };
}

const Main = defineComponent({
  name: "Main",
  components: {
    Sleepwalking,
    Timer
  },
  setup
});

export default Main;
</script>

<style scoped lang="scss">
.main {
  display: grid;
  box-sizing: border-box;
  grid-template:
    "timer" 1fr
    "answer" 8fr
    "question" 3fr
    "sleepwalking" 1fr
    / 90vw;
  row-gap: 10px;
  height: 100vh;
  margin: 0 5vw;
  padding: 20px 0;
  &__question {
    grid-area: question;
    place-self: center;
    width: 100%;
    height: 100%;
    padding: 0;
  }
  &__answer {
    grid-area: answer;
    // background-color: #cb0000;
    border-radius: 10px;
    place-self: center;
  }
  &__sleepwalking {
    grid-area: sleepwalking;
  }
  &__timer {
    grid-area: timer;
    justify-self: right;
    align-self: self-start;
  }
}

.question {
  &__input {
    width: 90%;
    height: 80%;
    max-width: 90%;
    max-height: 80%;
    min-width: 90%;
    min-height: 80%;
    margin: 5px;
    border: none;
    padding: 10px;
    border-radius: 15px;
    &:active,
    &:focus {
      border: none;
      text-decoration: none;
      outline: none;
      box-shadow: 0 0 20px -10px crimson;
      animation: background 5s infinite alternate;
      @keyframes background {
        50% {
          box-shadow: 0 0 20px -10px #5a4e8c;
        }
      }
    }
  }
  &__label {
    display: block;
    margin-left: 5%;
    margin-bottom: 5px;
    color: black;
    font-weight: normal;
    text-shadow: 1px 1px 2px #d9d9d9;
    font-size: 12px;
    width: 100%;
    text-align: left;
  }
}

.answer {
  &__text {
    font-size: 50px;
    color: #d9d9d9;
  }
}
</style>
